import { assign } from "lodash-es";
import normalizePositionByRangeLength from "./normalizePositionByRangeLength";
export default function normalizeRange(range, sequenceLength) {
  return assign({}, range, {
    start: normalizePositionByRangeLength(range.start, sequenceLength),
    end: normalizePositionByRangeLength(range.end, sequenceLength)
  });
}
